require('./manageOrganization.i18n.json');
require('./manageOrganization.tpl.html');
require('./manageOrganizationMediator.js');
require('./organizationActionMediator.js');
require('./organizationActionRepository.js');
require('./organizationActionUtil.js');
require('./emailSignatureModal/emailSignatureModal.i18n.json');
require('./emailSignatureModal/emailSignatureModal.tpl.html');
require('./emailSignatureModal/emailSignatureModalController');
require('./formViewer/manageOrganizationFormViewerController');

/*@ngInject*/
const ManageOrganizationController = function ($rootScope, $scope, $state, $stateParams, coreConstant, coreMediator, formSetMediator, formViewerConstant, loadingBarHandler, localization, modalUtil, navigationStateModel, organizationAction, organizationActionUtil, manageOrganizationMediator, organizationType, organizationStatus, organizationUtil) {

    localization.getTranslations().then(function (translations) {
        $scope.viewModel = {
            organization: null,
            organizationType: parseInt($stateParams.organizationType),
            formId: parseInt($stateParams.formId),
            formName: null,
            organizationId: $stateParams.organizationId,
            showFormNavigation: true,
            backButtonLabel: _.get(translations, 'organizationBrowser.title.' + $stateParams.organizationType)
        };

        $scope.actions = [];
        $scope.context = {
            identifier: 'organization',
            actions: {},
            fallthrough: null,
            model: {
                contextType: coreConstant.CONTEXT_NONE
            }
        };
        $scope.context.actions[coreConstant.CONTEXT_NONE] = '';

        function loadActions() {
            manageOrganizationMediator.loadOrganizationActions($stateParams.organizationType, $stateParams.organizationId).then(function (actions) {
                processActions(actions);
            });
        }

        function processActions(actions) {
            const allActions = [];
            allActions.push({
                actions: actions.actions,
                contextType: $scope.context.model.contextType
            });
            $scope.actions = allActions;
            $scope.actionsTimeLastModified = new Date().getTime();
        }

        $scope.upgradeForms = function () {
            if (!_.isNaN($scope.viewModel.formId)) {
                loadingBarHandler.showLoadingBar('loadingBar.defaultMessage');
                manageOrganizationMediator.upgradeForms($stateParams.organizationId).then(function (numberOfFormsUpgraded) {
                loadActions();
                    if (numberOfFormsUpgraded > 0) {
                        const formsText = numberOfFormsUpgraded === 1 ? _.get(translations, 'formsViewer.formUpgrade.singularMessage') : _.get(translations, 'formsViewer.formUpgrade.pluralMessage');

                        let message = _.get(translations, 'formsViewer.formUpgrade.message');
                        message = _.replace(message, '{1}', numberOfFormsUpgraded);
                        message = _.replace(message, '{2}', formsText);

                        modalUtil.showGenericConfirm({
                            title: _.get(translations, 'formsViewer.formUpgrade.title'),
                            summary: message,
                            confirmActionButtonLabel: _.get(translations, 'formsViewer.formUpgrade.confirmActionButtonLabel')
                        }).then(function () {
                            $state.reload();
                        });
                    }
                }).finally(function () {
                    loadingBarHandler.hideLoadingBar();
                });
            }
        }

        $scope.onSelectedFormChange = function (datasetItem) {
            const formId = datasetItem.id,
                upgradeForms = _.isNaN($scope.viewModel.formId);

            $state.go('configuration.manageOrganization.form', {formId: formId});
            $scope.viewModel.formId = formId;
            $scope.viewModel.formName = datasetItem.name;
            manageOrganizationMediator.savePreviousOrganization(
                $scope.viewModel.organization.id,
                $scope.viewModel.organizationType,
                $scope.viewModel.formId
            );

            if (upgradeForms) {
                $scope.upgradeForms();
            }
        };

        $scope.navigateToOrganizationList = function () {
            $state.go('configuration.organizationBrowser', {organizationType: $stateParams.organizationType});
            manageOrganizationMediator.resetPreviousOrganization();

            navigationStateModel.saveViewState('configuration.organizationBrowser:' + $stateParams.organizationType, null);
        };

        $scope.onMenuHasSingleItem = function () {
            $scope.viewModel.showFormNavigation = false;
        };
        $scope.onMenuHasMultipleItems = function () {
            $scope.viewModel.showFormNavigation = true;
        };

        $scope.getOrganizationStatus = function () {
            if (!_.isNil($scope.viewModel.organization)) {
                return _.get(translations, 'organization.manage.status.' + $scope.viewModel.organization.status);
            } else {
                return '';
            }
        };

        $scope.organizationStatusIsInactive = function () {
            if (!_.isNil($scope.viewModel.organization)) {
                return $scope.viewModel.organization.status === 0;
            } else {
                return false;
            }
        };

        $scope.$on(coreConstant.event.UPDATE_ORGANIZATION, function (event, organization) {
            if (organization.id === parseInt($stateParams.organizationId)) {
                $scope.viewModel.organization = organization;
                $scope.viewModel.organization.isDraftStatus = organization.status === organizationStatus.STATUS_DRAFT;
            }
        });

        $scope.$on(coreConstant.event.DELETE_ORGANIZATION, function (event, organization) {
            if (organization.id === parseInt($stateParams.organizationId)) {
                $scope.navigateToOrganizationList();
            }
        });

        $scope.$on('$destroy', function () {
            manageOrganizationMediator.closeOrganizationPersistentConnection($stateParams.organizationId);
        });

        manageOrganizationMediator.loadOrganizationById($stateParams.organizationId).then(function (organization) {
            $scope.viewModel.organization = organization;
            $scope.viewModel.organization.isDraftStatus = organization.status === organizationStatus.STATUS_DRAFT;
        });

        $scope.$on(coreConstant.event.UPDATE_ACTIONS_MESSAGE, function (event, updateActionsMessage, entityType, entityId) {
            if ((entityType === organizationType.AGENCY_STRING || entityType === organizationType.CARRIER_STRING || entityType === organizationType.MGA_CARRIER_STRING || entityType === organizationType.MGA_AGENCY_STRING) && parseInt($stateParams.organizationId) === entityId) {
                processActions(updateActionsMessage.actions);
            }
        });

        /*
         * reloadOrganization redisplays the organization's forms.
         * if formId or formName is specified, then the form with
         * that id or name is displayed; otherwise, the first form
         * is displayed.
         * The reason for specifying a form name is that some actions
         * (e.g., "Edit", "Discard", "Save") return a different set
         * of forms because of the carrier's modification-form-set.
         */
        function reloadOrganization(formId, formName) {
            manageOrganizationMediator.getForms($scope.viewModel.organizationId).then(function (result) {
                var nextFormId;
                result = _.filter(result, organizationUtil.isValidNavigationItem);
                nextFormId = result[0].id;
                if (formId || formName) {
                    _.each(result, function(item) {
                        if (item.id === formId || item.name === formName) {
                            nextFormId = item.id;
                            return false;
                        }
                        return true;
                    });
                }
                $state.go('configuration.manageOrganization.form', {formId: nextFormId}, {reload: true});
            });
        }

        function performOrganizationFormSetChanges(organizationActionType) {
            let promise = organizationActionUtil.getFormSetId($stateParams.organizationId).then(function (formSetId) {

                function handleDiscardConfirm() {
                    loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'organization.discardOrganizationChangesLoadingBar'));
                    let promise = formSetMediator.discardChanges(formSetId).then(function () {
                        reloadOrganization($scope.viewModel.formId, $scope.viewModel.formName);
                        loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'organization.discardOrganizationChangesSuccessLoadingBar'));
                    });
                    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
                    return promise;
                }

                if (organizationActionType === organizationAction.EDIT) {
                    let promise = formSetMediator.startChanges(formSetId).then(function () {
                        reloadOrganization($scope.viewModel.formId, $scope.viewModel.formName);
                    });
                    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
                } else if (organizationActionType === organizationAction.SAVE_CHANGES) {
                    loadingBarHandler.showNotificationLoadingBar(_.get(translations, 'organization.saveOrganizationChangesLoadingBar'));
                    let promise = formSetMediator.applyChanges(formSetId).then(function () {
                        reloadOrganization($scope.viewModel.formId, $scope.viewModel.formName);
                        loadingBarHandler.concludeNotificationLoadingBar(_.get(translations, 'organization.saveOrganizationChangesSuccessLoadingBar'));
                    });
                    $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
                } else if (organizationActionType === organizationAction.CANCEL_EDIT) {
                    modalUtil.showConfirmationModal(
                        null,
                        null,
                        null,
                        'organization.discard',
                        null,
                        /*hideLoadingBar*/true,
                        handleDiscardConfirm);
                }
            });
            $rootScope.$broadcast(coreConstant.event.ACTION_STARTED, promise);
        }

        $scope.handleAction = function (action) {
            if (action.enabled) {
                switch (action.name) {
                    case organizationAction.ACTIVATE:
                        organizationActionUtil.activateOrganization($stateParams.organizationId, false).then(function () {
                            $state.reload();
                        });
                        break;

                    case organizationAction.CANCEL:
                        organizationActionUtil.cancel($stateParams.organizationId);
                        break;

                    case organizationAction.DEACTIVATE:
                        organizationActionUtil.deactivateOrganization($stateParams.organizationId, false);
                        break;

                    case organizationAction.EDIT:
                        performOrganizationFormSetChanges(organizationAction.EDIT);
                        break;

                    case organizationAction.SAVE_CHANGES:
                        performOrganizationFormSetChanges(organizationAction.SAVE_CHANGES);
                        break;

                    case organizationAction.CANCEL_EDIT:
                        performOrganizationFormSetChanges(organizationAction.CANCEL_EDIT);
                        break;

                    case organizationAction.EDIT_EMAIL_SIGNATURE:
                        organizationActionUtil.editEmailSignature($scope.viewModel.organization);
                        break;

                    default:
                        modalUtil.showActionNotImplementedModal(action.name);
                        break;
                }
            }
        };

        $scope.$on(coreConstant.event.RELOAD_ACTIONS, function () {
            loadActions();
        });


        $scope.upgradeForms();
    });
};

angular.module('ums.configuration')
    .controller('manageOrganizationController', ManageOrganizationController);
